import { render, staticRenderFns } from "./GameSliderPage.vue?vue&type=template&id=601e0188&scoped=true"
import script from "./GameSliderPage.vue?vue&type=script&lang=js"
export * from "./GameSliderPage.vue?vue&type=script&lang=js"
import style0 from "./GameSliderPage.vue?vue&type=style&index=0&id=601e0188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e0188",
  null
  
)

export default component.exports